<script lang="ts" setup>
import { computed } from 'vue';

type AlertVariant = 'primary' | 'secondary' | 'secondary-light' | 'success' | 'danger' | 'warning' | 'light' | 'dark';

const show = defineModel<boolean>('show', { default: true });

const { variant = 'primary', align = 'center', closable } = defineProps<{
    align?: 'start' | 'center' | 'end';
    variant?: AlertVariant;
    closable?: boolean;
}>();

const emit = defineEmits<{
    close: [];
}>();

const icon = computed<string | null>(() => {
    switch (variant) {
        case 'warning': return 'WarningFilled';
        case 'success': return 'SuccessFilled';
        case 'primary': return 'InfoFilled';
        case 'danger': return 'ErrorFilled';
        default: return null;
    }
});

function close(): void {
    show.value = false;
    emit('close');
}
</script>

<template>
    <SAlert v-if="show" :variant="variant">
        <SStack :align-items="align" gap="3" :wrap="false">
            <SIcon v-if="icon" :icon="icon" size="20" />
            <div class="flex-grow-1">
                <slot></slot>
            </div>
            <SButton
                v-if="closable"
                square
                size="sm"
                icon="X"
                no-label
                aria-label="Close"
                @click="close"
            />
        </SStack>
    </SAlert>
</template>
